/**
 * FooterAccordion — mobile accordion menu for footer columns.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { FooterMenuColumn } from '../../types/footer';

export function FooterAccordion({ columns }: { columns: FooterMenuColumn[] }): JSX.Element {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <div className="divide-y divide-slate-200 dark:divide-slate-700">
      {columns.map((col) => (
        <div key={col.id}>
          <button
            onClick={() => setOpenId(openId === col.id ? null : col.id)}
            aria-expanded={openId === col.id}
            className="w-full flex items-center justify-between py-4 text-left"
          >
            <span className="font-display font-semibold text-slate-900 dark:text-white text-sm">
              {col.label}
            </span>
            <svg
              className={`h-4 w-4 text-slate-400 dark:text-slate-500 transition-transform duration-200 ${openId === col.id ? 'rotate-180' : ''}`}
              fill="none" viewBox="0 0 24 24" stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openId === col.id && (
            <ul className="pb-4 pl-2 space-y-2.5" role="list">
              {col.children.slice(0, 5).map((item) => (
                <li key={item.id}>
                  {item.url.startsWith('http') || item.url.startsWith('mailto:') || item.url.startsWith('tel:') ? (
                    <a href={item.url} target={item.target || '_self'} rel="noopener noreferrer" className="text-sm text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                      {item.label}
                    </a>
                  ) : (
                    <Link to={item.url} className="text-sm text-slate-500 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}
